/**
 * Google Authentication Service
 * Handles the Google connection flow.
 * Tokens come from provider-token-service via the backend.
 */

import providerLinkService from './ProviderLinkService';
import { devLog } from '../utils/devLog';

class GoogleAuthService {
  /**
   * Check whether the user has connected this provider
   * @returns {Promise<boolean>}
   */
  async isAuthenticated() {
    try {
      const status = await providerLinkService.checkLinkStatus('google');
      return status.linked;
    } catch (error) {
      console.error('❌ Google authentication check error:', error);
      return false;
    }
  }

  /**
   * Disconnect the provider and clear local credentials
   * @returns {Promise<void>}
   */
  async logout() {
    try {
      await providerLinkService.unlinkProvider('google');
      devLog('✅ Google logout successful');
    } catch (error) {
      console.error('❌ Google logout error:', error);
      throw error;
    }
  }
}

const GoogleAuth = new GoogleAuthService();
export default GoogleAuth;
